export const conversationResolutionGerman = {
  resolve: 'Als erledigt markieren',
  undo: 'Erledigung zurücknehmen',
  resolved: 'Manuell erledigt',
  resolvedAt: 'Manuell erledigt · {{time}}',
  resolvedSuccess: 'Unterhaltung manuell erledigt',
  undoSuccess: 'Erledigung zurückgenommen',
  failed: 'Der Gesprächsstatus konnte nicht geändert werden.',
  changed: 'Es gibt einen neueren Gesprächsstand. Prüfe ihn, bevor du die Unterhaltung erledigst.',
  unknown:
    'Keine Antwort vom Server. Ob der Gesprächsstatus geändert wurde, zeigt der neu geladene Stand.',
  offline: 'Keine Verbindung – der Gesprächsstatus kann gerade nicht geändert werden.',
  closeChannel: 'Im Buchungsportal schließen',
  noReplyChannel: 'Booking.com: Keine Antwort nötig',
  markRead: 'Als gelesen markieren',
};

export const conversationResolutionEnglish = {
  resolve: 'Mark as done',
  undo: 'Undo done status',
  resolved: 'Manually done',
  resolvedAt: 'Manually done · {{time}}',
  resolvedSuccess: 'Conversation marked as done',
  undoSuccess: 'Done status undone',
  failed: 'The conversation status could not be changed.',
  changed: 'The conversation has changed. Review the latest messages before marking it done.',
  unknown:
    'No response from the server. The reloaded conversation shows whether its status changed.',
  offline: 'No connection – the conversation status cannot be changed right now.',
  closeChannel: 'Close on booking channel',
  noReplyChannel: 'Booking.com: No reply needed',
  markRead: 'Mark as read',
};
